// 后台前端入口统一常量。
//
// 更换路径只能降低“随手猜测”和低成本扫描的可发现性，不能代替身份认证；
// 真实安全仍依赖登录限流、会话校验、未授权接口拒绝与错误脱敏。
// 本路径会进入前端构建产物，能被有意分析者发现，请不要把它当作密码使用。
export const ADMIN_BASE_PATH = '/cici-ops-7x9';
export const ADMIN_LOGIN_PATH = ADMIN_BASE_PATH;
export const ADMIN_DASHBOARD_PATH = `${ADMIN_BASE_PATH}/dashboard`;
